import type { EquipmentType } from "@vlab-corporation/vlab-pilates-service-interface/class";

export const EQUIPMENT_MOVEMENTS: Record<EquipmentType, string[]> = {
  reformer: [
    "Footwork (heels)",
    "Footwork (arches)",
    "Footwork (toes)",
    "Hundred",
    "Leg Circles",
    "Frog",
    "Lunge",
    "Knee Stretch",
    "Stomach Massage",
    "Short Box Series",
    "Long Stretch",
    "Down Stretch",
    "Up Stretch",
    "Elephant",
    "Running",
    "Pelvic Lift",
    "Mermaid",
    "Side Splits",
    "Front Splits",
  ],
  cadillac: [
    "Roll Down Bar",
    "Push Thru (sitting)",
    "Push Thru (supine)",
    "Swan Series",
    "Leg Springs (supine)",
    "Leg Springs (prone)",
    "Arm Springs",
    "Hanging Pull Up",
    "Tower",
    "Teaser",
    "Hip Flexor Stretch",
    "Walking",
  ],
  chair: [
    "Standing Roll Down",
    "Flat Back Roll Down",
    "One Leg Teaser",
    "Pike",
    "Seated Pumping",
    "Side Stretch",
    "Wunda Chair Footwork",
    "Mountain Climb",
    "Pull Up",
    "Tricep Press",
  ],
  barrel: [
    "하체 스트레칭 Series",
    "발레 스트레칭",
    "Side Stretch",
    "Back Extension",
    "Swan",
    "Leg Kicks",
    "Side Kicks",
    "Spine Stretch",
    "Seated Side Bend",
  ],
  mat: [
    "Hundred",
    "Roll Up",
    "Roll Over",
    "Leg Circles",
    "Rolling Like a Ball",
    "Series of Five",
    "Spine Stretch",
    "Rocker",
    "Cork Screw",
    "Saw",
    "Swan",
    "Single Leg Kicks",
    "Double Leg Kicks",
    "Neck Pull",
    "Scissors",
    "Bicycle",
    "Shoulder Bridge",
    "Spine Twist",
    "Jackknife",
    "Side Kicks",
    "Teaser",
    "Boomerang",
    "Ab Prep",
    "Dead Bug",
    "Cat Stretch",
    "Plank",
  ],
};
